/**
 * @licence MIT
 * @author Sergey Melyukov
 */
module.exports = require('./main');